<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;justify-content: space-between;padding: 0 20px;">
    <div class="biankuang" style="height: 100%;width: 100%;display:flex;flex-direction: column;">
      <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
        近90日维修分析
      </div>
      <div style="display:flex;justify-content:space-around;align-items:center;flex:1">
        <img style="width: 160px;height: auto;" src="../../../../../../../assets/img/web/yongxin/qianzi.png" />
        <div style="display:flex;justify-content:center;flex-direction:column;align-items:center">
          <p style="font-size:18px;color:white">总维修次数</p>
          <p style="color: rgba(250, 108, 28, 1);font-weight: bold;font-size: 46px;">{{ count1 }}</p>
        </div>
        <div style="">
          <!-- <p style="font-size:18px;color:white">维修次数Top3</p> -->
          <div style="display: flex;align-items: center;margin-top: 10px;">
            <div>
              <div v-for="(item, i) in list1" style="height: 40px;display: flex;align-items: center;">
                <img style="width: 30px;height: auto;" :src="require('../../../../../../../assets/img/web/yongxin/paiming' + (i + 1) + '.png')" />
              </div>
            </div>
            <div style="margin-left: 10px;">
              <div v-for="(item, i) in list1" style="height: 40px;display: flex;align-items: center;font-size:18px;color:white;">{{ item.equipmentName }}</div>
            </div>
            <div style="margin-left: 40px;">
              <div v-for="(item, i) in list1" style="height: 40px;display: flex;font-weight: bold;align-items: center;font-size:20px;color:rgba(250, 108, 28, 1);">{{ item.repairCount }}次</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="biankuang" style="height: 100%;width: 100%;display:flex;flex-direction: column;margin-left: 20px;">
      <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
        近90日保养分析
      </div>
      <div style="display:flex;justify-content:space-around;align-items:center;flex:1">
        <img style="width: 160px;height: auto;" src="../../../../../../../assets/img/web/yongxin/zuanshi.png" />
        <div style="display:flex;justify-content:center;flex-direction:column;align-items:center">
          <p style="font-size:18px;color:white">保养完成率</p>
          <p v-if="zongbaoyang != 0" style="color: rgba(6, 211, 235, 1);font-weight: bold;font-size: 46px;">{{ (wanchenglv * 100).toFixed(1) + '%' }}</p>
        </div>
        <div style="">
          <div style="display: flex;align-items: center;">
            <div style="margin-left: 10px;">
              <div style="height: 40px;display: flex;align-items: center;font-size:18px;color:white;">
                保养任务数
              </div>
              <div style="height: 40px;display: flex;align-items: center;font-size:18px;color:white;">
                已保养任务数
              </div>
              <div style="height: 40px;display: flex;align-items: center;font-size:18px;color:white;">
                未保养任务数
              </div>
            </div>
            <div style="margin-left: 40px;">
              <div style="height: 40px;display: flex;font-weight: bold;align-items: center;font-size:20px;color:rgba(6, 211, 235, 1);">
                {{ zongbaoyang }}
              </div>
              <div style="height: 40px;display: flex;font-weight: bold;align-items: center;font-size:20px;color:rgba(6, 211, 235, 1);">
                {{ yibaoyang }}
              </div>
              <div style="height: 40px;display: flex;font-weight: bold;align-items: center;font-size:20px;color:rgba(6, 211, 235, 1);">
                {{ weibaoyang }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_count',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      timer: null,
      count1: 0,
      wanchenglv: 0,
      list1: [],
      yibaoyang: 0,
      weibaoyang: 0,
      zongbaoyang: 0
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/equipment/repair/analysis');
      this.count1 = response.data.repairCount;
      this.list1 = response.data.resList;

      let response2 = await this.http.get('/custom/yongxin/equipment/maintenance/analysis');
      this.wanchenglv = response2.data.completionRate;
      this.yibaoyang = response2.data.maintainedTaskCount;
      this.weibaoyang = response2.data.notMaintainedTaskCount;
      this.zongbaoyang = response2.data.totalTaskCount;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 800);
    }
  }
};
</script>
